module.exports = __webpack_public_path__ + "img/BG.6025d5e0.png";